<template>
  <q-dialog v-model="aberto" persistent>
    <q-card style="min-width: 480px; max-width: 560px; border-radius: 12px">
      <!-- Cabeçalho -->
      <q-card-section class="row items-center q-pb-none">
        <div class="col">
          <div class="text-h6 text-brand-1 text-weight-bold">
            Certificação na Plataforma Multpex
          </div>
          <div class="text-caption text-grey-6 q-mt-xs">
            Garanta seu desenvolvimento contínuo
          </div>
        </div>
        <q-btn icon="close" flat round dense @click="fechar" />
      </q-card-section>

      <q-separator class="q-mt-sm" />

      <!-- Conteúdo -->
      <q-card-section class="q-pt-md">
        <p class="text-body1 text-brand-1">
          Olá! Identificamos que você ainda não possui uma certificação
          registrada no uso da plataforma Multpex.
        </p>
        <p class="text-body2 text-grey-7">
          A certificação garante que você aproveite ao máximo todos os recursos
          disponíveis e esteja alinhado com as melhores práticas. Como prefere
          prosseguir?
        </p>
      </q-card-section>

      <q-separator />

      <!-- Opções -->
      <q-card-section v-if="!mensagemVideos" class="q-gutter-sm q-pt-md">
        <!-- Opção 1 -->
        <q-card
          flat
          bordered
          class="opcao-card cursor-pointer"
          :class="{ 'opcao-loading': loadingOpcao === 1 }"
          @click="opcaoConfortavel"
        >
          <q-card-section class="row items-center q-py-sm">
            <q-icon
              name="thumb_up_off_alt"
              size="28px"
              color="teal"
              class="q-mr-md"
            />
            <div class="col">
              <div
                class="text-weight-bold text-brand-1"
                style="font-size: 13px"
              >
                Não preciso me certificar agora
              </div>
              <div class="text-caption text-grey-6">
                Me sinto confortável em manusear a plataforma
              </div>
            </div>
            <q-spinner v-if="loadingOpcao === 1" color="teal" size="20px" />
          </q-card-section>
        </q-card>

        <!-- Opção 2 -->
        <q-card
          flat
          bordered
          class="opcao-card cursor-pointer"
          :class="{ 'opcao-loading': loadingOpcao === 2 }"
          @click="opcaoAgendarCalendario"
        >
          <q-card-section class="row items-center q-py-sm">
            <q-icon name="event" size="28px" color="primary" class="q-mr-md" />
            <div class="col">
              <div
                class="text-weight-bold text-brand-1"
                style="font-size: 13px"
              >
                Quero agendar minha certificação
              </div>
              <div class="text-caption text-grey-6">
                Escolha um horário no nosso calendário de atendimento
              </div>
            </div>
            <q-spinner v-if="loadingOpcao === 2" color="primary" size="20px" />
          </q-card-section>
        </q-card>

        <!-- Opção 3 -->
        <q-card
          flat
          bordered
          class="opcao-card cursor-pointer"
          :class="{ 'opcao-loading': loadingOpcao === 3 }"
          @click="opcaoVideos"
        >
          <q-card-section class="row items-center q-py-sm">
            <q-icon
              name="play_circle_outline"
              size="28px"
              color="deep-orange"
              class="q-mr-md"
            />
            <div class="col">
              <div
                class="text-weight-bold text-brand-1"
                style="font-size: 13px"
              >
                Quero acessar vídeos de treinamento
              </div>
              <div class="text-caption text-grey-6">
                Consulte e realize o treinamento no seu ritmo
              </div>
            </div>
            <q-spinner
              v-if="loadingOpcao === 3"
              color="deep-orange"
              size="20px"
            />
          </q-card-section>
        </q-card>
      </q-card-section>

      <!-- Mensagem pós vídeos -->
      <q-card-section v-if="mensagemVideos" class="q-pt-md text-center">
        <q-icon
          name="mark_email_read"
          size="48px"
          color="primary"
          class="q-mb-md"
        />
        <p class="text-body1 text-brand-1 text-weight-bold">
          Ótimo! Nossa equipe já foi notificada.
        </p>
        <p class="text-body2 text-grey-7">
          Em breve você receberá um e-mail com os links dos vídeos de
          treinamento e materiais de apoio para consultar no seu ritmo.
        </p>
        <q-btn
          label="Fechar"
          no-caps
          style="background-color: #21324a; border-radius: 8px; color: white"
          class="q-mt-sm"
          @click="fechar"
        />
      </q-card-section>
      <q-separator v-if="!mensagemVideos" />
      <q-card-section v-if="!mensagemVideos" class="q-py-sm text-center">
        <span class="text-caption text-grey-7">
          Lembrando que nosso suporte está sempre à sua disposição! Se quiser
          entender mais sobre esse treinamento,
          <a
            href="https://wa.me/5511930315382"
            target="_blank"
            class="text-positive text-weight-bold"
            style="text-decoration: none"
          >
            <q-icon name="fab fa-whatsapp" size="14px" class="q-mr-xs" />nos
            chame aqui no WhatsApp </a
          >.
        </span>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
import { ref, watch } from "vue";
import { avisoTreinamentoService } from "../services/avisoTreinamentoService";

const CALENDAR_URL =
  "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ0H7LwFcOAL-TVrk0RNCKmPJs2zCg0ou_Vjh7Fq6CT7wJufOhmw0ABXVPwP3KLDXvGmUnhcnnP1";

export default {
  name: "AvisoTreinamentoModal",
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    userEmail: {
      type: String,
      default: "",
    },
    docId: {
      type: String,
      default: null,
    },
    userSap: {
      type: String,
      default: null,
    },
    userName: {
      type: String,
      default: null,
    },
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const aberto = ref(props.modelValue);
    const loadingOpcao = ref(null);
    const mensagemVideos = ref(false);

    watch(
      () => props.modelValue,
      (val) => {
        aberto.value = val;
      }
    );

    watch(aberto, (val) => {
      emit("update:modelValue", val);
    });

    const fechar = () => {
      aberto.value = false;
    };

    const executarOpcao = async (opcao, motivo, callback) => {
      loadingOpcao.value = opcao;
      await avisoTreinamentoService.notificarWebhook(
        motivo,
        props.userEmail,
        null,
        props.docId,
        props.userSap,
        props.userName
      );
      if (callback) callback();
      loadingOpcao.value = null;
      fechar();
    };

    const opcaoConfortavel = () => {
      executarOpcao(1, "confortavel");
    };

    const opcaoAgendarCalendario = () => {
      executarOpcao(2, "calendario", () => {
        window.open(CALENDAR_URL, "_blank");
      });
    };

    const opcaoVideos = async () => {
      loadingOpcao.value = 3;
      await avisoTreinamentoService.notificarWebhook(
        "videos",
        props.userEmail,
        null,
        props.docId,
        props.userSap,
        props.userName
      );
      loadingOpcao.value = null;
      mensagemVideos.value = true;
    };

    return {
      aberto,
      loadingOpcao,
      mensagemVideos,
      fechar,
      opcaoConfortavel,
      opcaoAgendarCalendario,
      opcaoVideos,
    };
  },
};
</script>

<style scoped>
.opcao-card {
  border-radius: 8px !important;
  transition: background-color 0.2s;
}
.opcao-card:hover {
  background-color: #f5f7fa;
}
.opcao-loading {
  opacity: 0.7;
  pointer-events: none;
}
</style>
